/**
 * Produto associado a cada rota, para marcar os eventos de analytics
 * (`product_line`) e para a mensagem padrão do WhatsApp do cabeçalho e do
 * botão flutuante mudar conforme a página do produto.
 */
export type ProductLine =
  | "internet"
  | "telefonia"
  | "cameras"
  | "hospedagem"
  | "datacenter"
  | "aplicativos"
  | "geral";

const ROUTE_PRODUCT: { prefix: string; line: ProductLine }[] = [
  { prefix: "/planos", line: "internet" },
  { prefix: "/telefonia", line: "telefonia" },
  { prefix: "/cameras", line: "cameras" },
  { prefix: "/hospedagem", line: "hospedagem" },
  { prefix: "/aplicativos", line: "aplicativos" },
];

export function routeProductLine(pathname: string): ProductLine {
  const hit = ROUTE_PRODUCT.find((r) => pathname.startsWith(r.prefix));
  return hit?.line ?? "geral";
}

const PRODUCT_MESSAGE: Record<ProductLine, string> = {
  internet: "Olá! Quero contratar a internet da Contato.",
  telefonia: "Olá! Quero contratar a telefonia da Contato.",
  cameras: "Olá! Quero contratar as câmeras de monitoramento da Contato.",
  hospedagem: "Olá! Quero contratar a Hospedagem da Contato.",
  datacenter: "Olá! Quero contratar o Data Center da Contato.",
  aplicativos: "Olá! Quero contratar os aplicativos de streaming da Contato.",
  geral: "Olá! Quero contratar a internet da Contato.",
};

/** Mensagem padrão do WhatsApp para os botões "genéricos" (topo, flutuante) de uma rota. */
export function productMessage(pathname: string): string {
  return PRODUCT_MESSAGE[routeProductLine(pathname)];
}
